import { Component, OnInit, OnDestroy } from "@angular/core";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";
import { ViewChild } from "@angular/core";

import { DialogService } from "primeng/dynamicdialog";
import { ConfirmationService } from "primeng/api";

import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";

import { UserService } from "../../../shared/services/user.service";
import { SchoolInfo } from "./shared/SchoolInfo";
import { DataService_itemcollection } from "./shared/data.service";

import { wsItemCollectionStudentInfoParm } from "./shared/wsItemCollectionStudentInfo";
import { wsItemCollectionStudentInfo } from "./shared/wsItemCollectionStudentInfo";
import { wsItemCollectionStudentUpdateInfo } from "./shared/wsItemCollectionStudentInfo";

import { ItemCollectionAddEditComponent } from "./itemcollectionaddedit/itemcollectionaddedit.component";

import { Console } from "console";

@Component({
	selector: "app-root",
	templateUrl: "./itemcollection.component.html",
	styleUrls: ["./itemcollection.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class ItemCollectionComponent implements OnInit, OnDestroy 
{
	@ViewChild("mydt") mydt: Table;

	@ViewChild("filterReturned", { static: false }) 
	public filterReturned: Dropdown;

	@ViewChild("filterScanPersonalItemClassDesc", { static: false }) 
	public filterScanPersonalItemClassDesc: Dropdown;

	@ViewChild("ScanPersonalItemConditionDesc", { static: false })
	public ScanPersonalItemConditionDesc: Dropdown;

	constructor(
		private confirmationService: ConfirmationService, 
		private dialogService: DialogService, 
		private selectService: SchoolselectorService, 
		private dataService: DataService_itemcollection, 
		private userService: UserService, 
		private schoolService: SchoolService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;
	public isShowSyncInfo: boolean = false;
	public ErrorMessage: string = "";

	//	School Selector
	public subscriptionSchoolSelector: any;
	public SelectedSchool: SchoolInfo;	

	//	DateRange Selector
	public lstDateRange: any = [];
	public SelectedDateRange: any;
	public rStartDate: Date = new Date();
	public rEndDate: Date = new Date();	

	//	Depot Printers List
	public lstItemCollectionStudent: wsItemCollectionStudentInfo[] = [];

	//	Alert List
	public SelectedItemCollectionStudent: wsItemCollectionStudentInfo;

	//	Filters
	public lstReturned: any = [];
	public lstScanPersonalItemClassDesc: any = [];
	public lstScanPersonalItemConditionDesc: any = [];

	//	Alert Counts
	public pagefirst: number = 0;
	public pagerows: number = 10;

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() 
	{
		this.user = this.userService.getCurrentUser();

		//
		//	Set DateRange Selector
		//
		this.lstDateRange = [
			{ DateRangeID: 1, DateRangeDesc: "Today", LastXMonths: 0 },
			{ DateRangeID: 2, DateRangeDesc: "Last Month", LastXMonths: 1 },
			{ DateRangeID: 3, DateRangeDesc: "Last 2 Months", LastXMonths: 2 },
			{ DateRangeID: 4, DateRangeDesc: "Last 3 Months", LastXMonths: 3 },
			{
				DateRangeID: 5,
				DateRangeDesc: "Current School Year",
				LastXMonths: 99,
			},
			{
				DateRangeID: 6,
				DateRangeDesc: "Custom Date Range",
				LastXMonths: -1,
			},
			{ DateRangeID: 7, DateRangeDesc: "All", LastXMonths: 12000 },
		];

		this.SelectedDateRange = this.lstDateRange[0];

		// Process School Selection
		this.isBusy = true;
		this.subscriptionSchoolSelector = this.selectService.onSchoolChanged().subscribe((school) => {this.onSchoolChange(school);});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() 
	{
		this.subscriptionSchoolSelector.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrinterLockoutSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ItemCollectionStudentSelectList_Complete(data: any) 
	{
		this.SelectedItemCollectionStudent = null;
		this.lstItemCollectionStudent = data;
		
		//
		//	Set Filter Lists
		//
		this.lstReturned = Array.from(new Set(this.lstItemCollectionStudent.map((item: any) => item.Returned)));
		this.lstScanPersonalItemClassDesc = Array.from(new Set(this.lstItemCollectionStudent.map((item: any) => item.ScanPersonalItemClassDesc)));
		this.lstScanPersonalItemConditionDesc = Array.from(new Set(this.lstItemCollectionStudent.map((item: any) => item.ScanPersonalItemConditionDesc)));

		//
		//	Set Filter Defaults
		//
		this.onSetFilterDefaults();

		//
		//	Reset Sort
		//
		this.mydt.multiSortMeta = [];
		this.mydt.multiSortMeta.push({ field: "CollectionDT", order: 1 });
		this.mydt.sortMultiple();

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() 
	{
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() 
	{
		this.ErrorMessage = "";
	
		let StartDateParm = new Date();
		StartDateParm.setHours(0, 0, 0, 0); // Clear Hours

		let EndDateParm = new Date();
		EndDateParm.setHours(0, 0, 0, 0); // Clear Hours

		if (this.SelectedDateRange.DateRangeID == 6) {
			// Custom Date Range
			if (this.rStartDate == null) {
				this.ErrorMessage = "Invalid Start Date";
				return;
			} else {
				StartDateParm = this.rStartDate;
				StartDateParm.setHours(0, 0, 0, 0); // Clear Hours
			}

			if (this.rEndDate == null) {
				this.ErrorMessage = "Invalid End Date";
				return;
			} else {
				EndDateParm = this.rEndDate;
				EndDateParm.setHours(0, 0, 0, 0); // Clear Hours
			}

			if (this.rStartDate > this.rEndDate) {
				this.ErrorMessage = "Start Date cannot be greater than End Date";
				return;
			}
		}

		let parm: wsItemCollectionStudentInfoParm = {
			SchoolID: this.SelectedSchool.SchoolID,
			LastXMonths: this.SelectedDateRange.LastXMonths,
			StartDate: StartDateParm,
			EndDate: EndDateParm,
		};		

		this.isBusy = true;
		this.dataService.ItemCollectionStudentSelectList(parm).subscribe((data) => this.ItemCollectionStudentSelectList_Complete(data));	
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleReturned
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleReturned() 
	{
		this.ErrorMessage = "";

		if (this.SelectedItemCollectionStudent == null) {
			this.ErrorMessage = "Please select a collected item.";
			return;
		}		

		if (this.SelectedItemCollectionStudent.Returned == "Yes")
		{
			this.SelectedItemCollectionStudent.Returned = "No";
		}
		else
		{
			this.SelectedItemCollectionStudent.Returned = "Yes";
		}
	
		this.onUpdateReturned() 
	}	

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddItem
	//
	//-----------------------------------------------------------------------------------------------------
	onAddItem() 
	{
		this.ErrorMessage = "";

		var ref = this.dialogService.open(ItemCollectionAddEditComponent, {
			header: "Collect Item",
			width: "fit-content",
			data: { ScanPersonalItemID: "", Log_PersonID: this.user.personID, LogByFullName: this.user.userName },
		});

		ref.onClose.subscribe((response) => {
			if (response == 1) {
				//
				//	Refresh Q
				//
				this.onRefresh();
			}
		});

	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEditItem
	//
	//-----------------------------------------------------------------------------------------------------
	onEditItem() 
	{
		this.ErrorMessage = "";

		if (this.SelectedItemCollectionStudent == null) {
			this.ErrorMessage = "Please select a collected item.";
			return;
		}

		let parm: string = this.SelectedItemCollectionStudent.ScanPersonalItemID;

		if (parm.length != 0) 
		{
			var ref = this.dialogService.open(ItemCollectionAddEditComponent, {
				header: "Edit Collected Item",
				width: "fit-content",
				data: { ScanPersonalItemID: parm, Log_PersonID: this.user.personID, LogByFullName: this.user.userName },
			});

			ref.onClose.subscribe((response) => {
				if (response == 1) {
					//
					//	Refresh Q
					//
					this.onRefresh();
				}
			});
		}		
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleShowSyncData
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleShowSyncData() 
	{
		this.isShowSyncInfo = !this.isShowSyncInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSetFilterDefaults
	//
	//-----------------------------------------------------------------------------------------------------
	onSetFilterDefaults() 
	{
		this.mydt.filters.Returned["value"] = null; 						// Default To 'Any'
		this.mydt.filters.ScanPersonalItemClassDesc["value"] = null; 		// Default To 'Any'
		this.mydt.filters.ScanPersonalItemConditionDesc["value"] = null; 	// Default To 'Any'
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelect(event) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselect(event) 
	{
		//
		//	Need to set SelectedItemCollectionStudent here. We don't unselect when selected.
		//
		this.SelectedItemCollectionStudent = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}


	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowDblClick
	//
	//-----------------------------------------------------------------------------------------------------
	onRowDblClick(item: any) 
	{
		this.onEditItem() 
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdateReturned
	//
	//-----------------------------------------------------------------------------------------------------
	onUpdateReturned() 
	{
		if (this.SelectedItemCollectionStudent == null) {
			this.ErrorMessage = "Please select a collected item.";
			return;
		}		

		let parm: wsItemCollectionStudentUpdateInfo = 
		{
			ScanPersonalItemID: this.SelectedItemCollectionStudent.ScanPersonalItemID,
			Returned: this.SelectedItemCollectionStudent.Returned
		};

		this.isBusy = true;
		this.dataService.ItemCollectionStudentUpdate(parm).subscribe((data) => this.onUpdateReturned_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdateReturned_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	onUpdateReturned_Complete(data: any) 
	{
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSchoolChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSchoolChange(value) 
	{
		if (value == undefined || value.SchoolID == undefined)
		{
			this.lstItemCollectionStudent = [];
			this.isBusy = false;		
		}
		else	
		{
			this.SelectedSchool = value;

			if (this.SelectedSchool.SchoolID > 0) 
			{
				this.onRefresh()
			} 
			else 
			{
				this.lstItemCollectionStudent = [];
				this.isBusy = false;
			}

		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onDateRangeChange
	//
	//-----------------------------------------------------------------------------------------------------
	onDateRangeChange(value) {
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStartDateChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStartDateChange(val) {
		this.rStartDate = val;
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEndDateChange
	//
	//-----------------------------------------------------------------------------------------------------
	onEndDateChange(val) {
		this.rEndDate = val;
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------

}
